import React, { memo, useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import {
  CHANGE_SUBSCRIPTION,
  GET_PLANS,
  SET_SUBSCRIPTIONS,
  GET_SUBSCRIPTION_ERROR
} from '../../redux/actions'

import Loading from '../Loading'
import PlansContainer from '../../containers/plans/PlansContainer'

export default memo(function PlansComponent() {
  const { isAuthenticated, keycloak } = useSelector(state => state.auth)
  const { data: subscription, isLoading, subscriptionsPlanIds, subscriber, error } = useSelector(state => state.subscription)
  const { plans, isLoading: isLoadingPlans } = useSelector(state => state.plans)

  const [isSameUser, setIsSameUser] = useState(true)
  const [isOpenPreferredPlan, setIsOpenPreferredPlan] = useState(true)
  const [email, setEmail] = useState('')

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id: userId } = useParams()
  const location = useLocation()
  const [searchParams] = useSearchParams();
  const preferredPlan = searchParams.get('preferredPlan');

  useEffect(() => {
    !isAuthenticated && !isEmpty(keycloak) && keycloak.login()
  }, [isAuthenticated, keycloak])

  useEffect(() => {
    if (isAuthenticated && !isEmpty(userId)) {
      if (keycloak.subject !== userId) {
        setEmail(keycloak.userInfo?.email || '')
        setIsSameUser(false)
      } else {
        setEmail('')
        setIsSameUser(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, userId])

  useEffect(() => {
    isAuthenticated
      && isEmpty(plans)
      && dispatch(GET_PLANS({ keycloak }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  useEffect(() => {
    !isEmpty(subscriber) && !isEmpty(subscriber.idp_id)
      && navigate('/inicio')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriber])

  useEffect(() => {
    if (!isEmpty(subscription) && !isEmpty(plans)) {
      if (subscription.Plan.id === process.env.REACT_APP_MS_PLAN_FULL_LEGACY || subscription.Plan.id === process.env.REACT_APP_MS_PLAN_FULL_ANUAL_LEGACY) {
        plans.splice(0, 1, {
          ...subscription.Plan,
          shortName: subscription.Plan.name,
          show_on_plans: true,
          attributes: subscription.Plan.id === process.env.REACT_APP_MS_PLAN_FULL_LEGACY
            ? [
              { icon: "devicePhone", description: "Hasta 2 dispositivos conectados simultáneamente", active: true },
              { icon: "signal", name: "Señales en vivo", description: "Mega, Meganoticias, Radios y Mega 2", active: true },
              { icon: "playOutline", name: "VOD", description: "Teleseries y películas nacionales, series, documentales y reality", active: true },
              { icon: "signal", description: "Eventos en vivo", active: true },
              { icon: "playOutline", description: "Capítulos sin publicidad", active: true },
              { icon: "deviceTv", description: "Preestrenos 24 horas antes que en TV abierta", active: true },
            ]
            : subscription.Plan.id === process.env.REACT_APP_MS_PLAN_FULL_ANUAL_LEGACY
              ? [
                { icon: "devicePhone", description: "Hasta 2 dispositivos conectados simultáneamente", active: true },
                { icon: "signal", name: "Señales en vivo", description: "Mega, Meganoticias, Radios y Mega 2", active: true },
                { icon: "playOutline", name: "VOD", description: "Teleseries y películas nacionales, series, documentales y reality", active: true },
                { icon: "signal", description: "Eventos en vivo", active: true },
                { icon: "playOutline", description: "Capítulos sin publicidad", active: true },
                { icon: "deviceTv", description: "Preestrenos 24 horas antes que en TV abierta", active: true },
              ]
              : []
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription, plans])

  useEffect(() => {
    preferredPlan && setIsOpenPreferredPlan(true)
  }, [preferredPlan])
  
  const handleOnPayPlan = ({ planId, isSubscription }) => {
    let distributorID;
    if (location.pathname.includes('/roku/planes')) {
      distributorID = process.env.REACT_APP_DISTRIBUTOR_ID_ROKU
    }
    dispatch(SET_SUBSCRIPTIONS({ keycloak, planId, isSubscription, distributor_id: distributorID }))
  }

  const handleOnChangePlan = ({ planId }) => {
    dispatch(CHANGE_SUBSCRIPTION({ keycloak, planId, subscriptionId: subscription.id }))
  }

  const closeErrorModal = () => {
    dispatch(dispatch(GET_SUBSCRIPTION_ERROR(false)))
  }

  const closePreferredPlanModal = () => {
    setIsOpenPreferredPlan(false)
  }

  const reloadPage = () => {
    window.location.reload()
  }

  return (
    isLoading || isLoadingPlans
      ? <Loading />
      : <PlansContainer
        email={email}
        handleOnPayPlan={handleOnPayPlan}
        handleOnChangePlan={handleOnChangePlan}
        navigate={navigate}
        isSameUser={isSameUser}
        keycloak={keycloak}
        plans={plans}
        setIsSameUser={setIsSameUser}
        subscription={subscription}
        subscriptionsPlanIds={subscriptionsPlanIds}
        userId={userId}
        closeErrorModal={closeErrorModal}
        reloadPage={reloadPage}
        error={error}
        preferredPlan={preferredPlan}
        isOpenPreferredPlan={isOpenPreferredPlan}
        closePreferredPlanModal={closePreferredPlanModal}
      />
  )
})